var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-demo"},[_c('yet-another-arch'),_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"10","lg":"6"}},[_c('wistia-video',{staticClass:"elevation-8 mb-10 mt-10"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }